import * as React from "react";
import { useTranslations } from "../i18n/useTranslations";
import { HistoryIcon } from "../icons/HistoryIcon";
import { SearchIcon } from "../icons/SearchIcon";
import { prefixedWithLang } from "../utils";

type Props = {
  searchItems: string[];
  listType: string;
  searchText?: string;
};

function escapeRegExp(str: string) {
  return str.replace(/[-[\]/{}()*+?.\\^$|]/g, "\\$&");
}

function getItemWithHighlights(text: string, query: string) {
  const regex = new RegExp(escapeRegExp(query), "gi");
  const newText = text.replace(
    regex,
    `<mark class="elm-font-semibold elm-bg-transparent elm-text-dd-gray-900">$&</mark>`
  );
  return <span dangerouslySetInnerHTML={{ __html: newText }}></span>;
}

export function SearchList({ searchItems, listType, searchText }: Props) {
  const { lang } = useTranslations();
  const listIcon = listType === "history" ? <HistoryIcon /> : <SearchIcon />;

  return (
    <ul className="elm-m-0 elm-p-0 elm-list-none">
      {searchItems.map((item, index) => (
        <li
          key={index}
          className="elm-border-0 elm-border-b elm-border-solid elm-border-dd-gray-300 elm-block"
        >
          <a
            href={prefixedWithLang(lang, `search?s=${item}`)}
            className="lg:hover:elm-text-dd-gray-500 elm-py-3 focus:elm-outline-none elm-text-base elm-cursor-pointer elm-pointer-events-auto elm-no-underline elm-flex elm-items-center"
          >
            {listIcon}
            <span className="elm-text-dd-gray-900 elm-font-sans elm-text-lg elm-ml-3">
              {listType === "history" ? item : getItemWithHighlights(item, searchText)}
            </span>
          </a>
        </li>
      ))}
    </ul>
  );
}
